import styled, { keyframes } from "styled-components";

const INK = "#121214";
const PAPER = "#EFEFEC";
const MUTED = "#5E5E66";
const BOUNCE = "cubic-bezier(0.34, 1.56, 0.64, 1)";

const rowIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: none;
  }
`;

export const Container = styled.div`
  min-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${PAPER};
  color: ${INK};
`;

const Inner = styled.div`
  max-width: 1120px;
  width: 100%;
  margin-inline: auto;
  padding-inline: 32px;

  @media (max-width: 600px) {
    padding-inline: 16px;
  }
`;

export const Header = styled.header`
  background-color: ${INK};
  color: #fff;
`;

export const HeaderInner = styled(Inner)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  min-height: 88px;
  padding-block: 20px;
`;

export const Logo = styled.img`
  max-width: 220px;
  max-height: 48px;
  object-fit: contain;
`;

export const ProjectCount = styled.span`
  margin-left: auto;
  font-size: 13px;
  font-weight: 600;
  color: #b9b9c2;
`;

export const Hero = styled(Inner)`
  padding-top: 72px;
  padding-bottom: 40px;

  @media (max-width: 600px) {
    padding-top: 40px;
  }
`;

export const Title = styled.h1`
  margin: 0;
  font-size: clamp(48px, 9vw, 88px);
  font-weight: 800;
  letter-spacing: -0.045em;
  line-height: 0.95;

  span {
    color: #9a9aa2;
  }
`;

export const ProjectList = styled(Inner)`
  padding-bottom: 72px;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    border-top: 2px solid ${INK};
  }
`;

export const Thumbnail = styled.span`
  width: 96px;
  height: 64px;
  border-radius: 10px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  overflow: hidden;
  transition: transform 0.35s ${BOUNCE}, background-color 0.3s;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const ProjectIndex = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #8a8a92;
  transition: color 0.3s;
`;

export const ProjectNames = styled.span`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 16px;
  min-width: 0;
`;

export const ClientName = styled.span`
  font-size: clamp(20px, 2.4vw, 26px);
  font-weight: 800;
  letter-spacing: -0.02em;
`;

export const ProjectName = styled.span`
  font-size: 16px;
  color: ${MUTED};
  transition: color 0.3s;
`;

export const Arrow = styled.span`
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.35s ${BOUNCE};
`;

export const ProjectItem = styled.li`
  animation: ${rowIn} 0.5s ${BOUNCE} both;
  animation-delay: ${({ $index }) => Math.min($index, 12) * 50}ms;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const ProjectLink = styled.a`
  display: grid;
  grid-template-columns: 48px 96px minmax(0, 1fr) auto;
  align-items: center;
  gap: 20px;
  padding: 18px 8px;
  border-bottom: 1px solid #d3d3ce;
  color: ${INK};
  text-decoration: none;
  transition: background-color 0.3s, color 0.3s, padding 0.35s ${BOUNCE};

  &:hover,
  &:focus-visible {
    background-color: ${INK};
    color: #fff;
    padding-inline: 32px;
    outline: none;

    ${Thumbnail} {
      transform: scale(1.12) rotate(-3deg);
    }

    ${Arrow} {
      transform: translateX(6px) rotate(-45deg);
    }

    ${ProjectIndex}, ${ProjectName} {
      color: #b9b9c2;
    }
  }

  @media (max-width: 600px) {
    grid-template-columns: 72px minmax(0, 1fr) auto;
    gap: 14px;

    ${ProjectIndex} {
      display: none;
    }

    ${Thumbnail} {
      width: 72px;
      height: 52px;
    }
  }
`;

export const Footer = styled.footer`
  margin-top: auto;
  background-color: ${INK};
  color: #fff;
  padding: 36px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const SubContainerLogos = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  flex-wrap: wrap;
`;

export const LogoAgency = styled.img`
  transition: 0.3s;
  object-fit: contain;
  &:hover {
    filter: opacity(0.5);
  }
`;

export const EdgLogo = styled.img`
  width: 100%;
  max-width: 400px;
  object-fit: contain;
  transition: 0.3s;
  filter: invert(1);
  &:hover {
    filter: invert(0.5);
  }
`;
